import useOn from './useOn';
import useStateEmit from './useStateEmit';

/**
 * Custom Hook that combines `useStateOn` and `useStateEmit`
 * @param event The event you want to listen for and emit
 * @param initialState The initial state
 * @returns [state, setState, setStateEmit]
 * state is the state. setState sets the state. setStateEmit sets the state and emits the `event` parameter. You can emit extra arguments too
 */
const useStateSocket = <S>(event: string, initialState: S | (() => S)) => {
	const stateEmitTuple = useStateEmit(event, initialState), [, setState] = stateEmitTuple;

	useOn(event, setState);

	return stateEmitTuple;
};

export default useStateSocket;